import type { PostFormat, SocialPlatform } from "@nlc/shared-types";

export interface InsightsFilters {
  brandIds?: number[];
  days: number;
  format?: PostFormat;
  platform?: SocialPlatform;
}

export const DATE_RANGE_OPTIONS = [
  { days: 7, label: "Last 7 days" },
  { days: 28, label: "Last 28 days" },
  { days: 90, label: "Last 90 days" },
];

export const DEFAULT_INSIGHTS_FILTERS: InsightsFilters = { days: 28 };
